export default __webpack_public_path__ + "static/media/montparnasseMinia.16ffc273.png";